import { render, staticRenderFns } from "./case.vue?vue&type=template&id=4c1cc057&scoped=true"
import script from "./case.vue?vue&type=script&lang=js"
export * from "./case.vue?vue&type=script&lang=js"
import style0 from "./case.vue?vue&type=style&index=0&id=4c1cc057&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1cc057",
  null
  
)

export default component.exports